import {
  Component,
  ViewChild
} from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import {Router } from '@angular/router';
import * as _ from 'underscore';
import {
  FormBuilder
} from '@angular/forms';
import { SearchComponent } from 'src/app/components/search/search.component';
import SwalAlert from 'src/app/utils/swalalert';
import { BlocksService } from 'src/app/api/report/blocks.service';

@Component({
  selector: 'app-blockshotel',
  templateUrl: './blockshotel.component.html',
  styleUrls: ['./blockshotel.component.css']
})
export class BlockshotelComponent {
  branchofficeSlug = '';
  items: any = [];
  params: any = {
    search: ''
  };
  page = 1;
  count = 0;

  @ViewChild(SearchComponent) searchComponent: any;

  dataPagination: any = {
    pageSize: 0,
    currentPage: this.page,
    totalItems: 0
  };

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private globalService: GlobalService,
    private blocksService: BlocksService,
    private alert: SwalAlert
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    
  }

  ngOnInit() {
    this.list();
  }

  list() {
    let val_params = 'search=' + this.params.search + '&page=' + this.page;
    this.blocksService.blocksHotelList(val_params).subscribe({
      next: (data: any) => {
        this.items = data.results;
        this.dataPagination.pageSize = data.paginate_by;
        this.dataPagination.currentPage = this.page;
        this.dataPagination.totalItems = data.total;
      }
    });
  }

  search(text: any) {
    this.params.search = text;
    this.page = 1;
    this.list();
  }

  handlePageChange(event: any): void {
    this.page = event;
    this.list();
  }

  refresh() {
    this.page = 1;
    this.params.search = '';
    this.searchComponent.textSearch = '';
    this.list();
  }

  detail(id: number) {
    this.router.navigate([
      this.branchofficeSlug + '/reportes/cuadreshotel/detalle',
      id
    ]);
  }

  delete(item: any, _index:any) {
    let options = {
      title: '¿Estás segur@?',
      message: item.description,
      cancel: 'Cancelar',
      confirm: 'Eliminar'
    };
    this.alert.confirmDelete(options).then((result: any) => {
      if (result.isConfirmed) {
        // this.blocksService.delete(item.id).subscribe({
        //   next: (data: any) => {
        //     this.items.splice(_index, 1);
        //     this.alertifyMsg.success('El registro '+item.description+' se ha eliminado con éxito');
        //     this.list();
        //   }
        // });
      }
    });
  }

  cancel() {
    this.router.navigate([
      this.branchofficeSlug + '/reportes/lista'
    ]);
  }

}
